// ============================================================
// ExamContext.jsx - نسخه نهایی با تفکیک کامل آزمون‌های عمومی و چالش‌ها
// ============================================================

import React, { createContext, useState, useContext, useEffect, useCallback, useRef } from 'react';
import { deleteExamImages, deleteImage } from '../../services/ImageService';
// 🔽 CHANGED: curriculum helpers برای پشتیبانی از رشته (فقط پایه‌های ۱۰-۱۲)
// 🔽 CHANGED: curriculum helpers برای پشتیبانی از رشته (فقط پایه‌های ۱۰-۱۲)
import {
  needsField as curriculumNeedsField,
  normalizeFieldId as curriculumNormalizeField,
} from '../../core/education/curriculum.js';

import { engine as booksEngine } from '../../core/books/storage.js';
import { progressManager } from '../../core/books/logic.js';

// ============================================================
// ✅ همگام‌سازی آزمون‌ها با سرور (json-server روی پورت 3001)
// ============================================================
const EXAM_API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';
// ============================================================
// ===== ادمین‌های ویژه (فقط کاربران با نقش admin یا superadmin) =====
// ============================================================
export const GLOBAL_ADMINS = []; // دیگر استفاده نمی‌شود

/**
 * بررسی اینکه کاربر ادمین ویژه است یا خیر (بر اساس نقش)
 * @param {string} userId - شناسه کاربر (اختیاری)
 * @returns {boolean} آیا ادمین ویژه است
 */
export const isGlobalAdmin = (userId) => {
  if (!userId) return false;

  try {
    // ✅ منبع ۱: users cache در window (از teamService پر می‌شه)
    if (typeof window !== 'undefined' && Array.isArray(window.__allUsersCache)) {
      const user = window.__allUsersCache.find((u) => u && String(u.id) === String(userId));
      if (user && (user.role === 'admin' || user.role === 'superadmin')) {
        return true;
      }
    }

    // ✅ منبع ۲ (fallback): localStorage.user
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const user = JSON.parse(storedUser);
      if (user && String(user.id) === String(userId)
          && (user.role === 'admin' || user.role === 'superadmin')) {
        return true;
      }
    }

    // ✅ منبع ۳ (fallback): localStorage.users
    const storedUsers = localStorage.getItem('users');
    if (storedUsers) {
      const users = JSON.parse(storedUsers);
      if (Array.isArray(users)) {
        const found = users.find((u) => u && String(u.id) === String(userId));
        if (found && (found.role === 'admin' || found.role === 'superadmin')) {
          return true;
        }
      }
    }
  } catch (e) {
    console.warn('Error checking user role:', e);
  }

  return false;
};
// ============================================================
// ===== توابع ابزار (Utility Functions) =====
// ============================================================

/**
 * تبدیل ایمن مقدار به عدد
 * @param {any} value - مقداری که باید به عدد تبدیل شود
 * @param {number} defaultValue - مقدار پیش‌فرض در صورت عدم موفقیت
 * @returns {number} عدد تبدیل شده یا مقدار پیش‌فرض
 */
export const toNumber = (value, defaultValue = 0) => {
  const num = Number(value);
  return isNaN(num) ? defaultValue : num;
};

/**
 * ✅ مقایسه امن ID — string و number رو یکسان می‌بینه
 * مثال: idsEqual(1, "1") === true
 */
export const idsEqual = (a, b) => {
  if (a === null || a === undefined || b === null || b === undefined) return false;
  return String(a) === String(b);
};

/**
 * محاسبه نمره قبولی بر اساس نمره کل

/**
 * ✅ مقایسه امن ID — string و number رو یکسان می‌بینه
 * مثال: idsEqual(1, "1") === true
 */


/**
 * محاسبه نمره قبولی بر اساس نمره کل

/**
 * محاسبه نمره قبولی بر اساس نمره کل

/**
 * محاسبه نمره قبولی بر اساس نمره کل
 * @param {number} maxScore - حداکثر نمره آزمون
 * @returns {number} نمره قبولی (۵۰٪ نمره کل)
 */
export const calculatePassThreshold = (maxScore) => {
  if (maxScore <= 0) return 0;
  return Math.ceil(maxScore * 0.5);
};

/**
 * سانیتایز کردن HTML برای جلوگیری از XSS
 * @param {string} html - محتوای HTML
 * @returns {string} محتوای سانیتایز شده
 */
export const sanitizeHtml = (html) => {
  if (!html) return '';
  
  const dangerousTags = ['script', 'iframe', 'object', 'embed', 'form', 'input', 'button', 'textarea', 'select', 'option', 'link', 'meta', 'style'];
  let sanitized = html;
  
  dangerousTags.forEach(tag => {
    const regex = new RegExp(`<${tag}[^>]*>.*?<\/${tag}>`, 'gis');
    sanitized = sanitized.replace(regex, '');
    const regexSelf = new RegExp(`<${tag}[^>]*\/>`, 'gi');
    sanitized = sanitized.replace(regexSelf, '');
  });
  
  sanitized = sanitized
    .replace(/on\w+="[^"]*"/g, '')
    .replace(/on\w+='[^']*'/g, '')
    .replace(/javascript:/gi, '')
    .replace(/data:/gi, '')
    .replace(/vbscript:/gi, '')
    .replace(/onerror=/gi, '')
    .replace(/onload=/gi, '')
    .replace(/onclick=/gi, '')
    .replace(/onmouseover=/gi, '');
  
  return sanitized;
};

// ============================================================
// ===== توابع داخلی (Internal Functions) =====
// ============================================================

/**
 * تولید شناسه یکتا
 * @returns {string} شناسه یکتا
 */
const generateId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substring(2, 9);
};

/**
 * دریافت داده‌های اولیه آزمون‌ها از localStorage
 * @returns {Array|null} آرایه آزمون‌ها یا null
 */
const getInitialExams = () => {
  try {
    const stored = localStorage.getItem('exams');
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return null;
      }
    }
  } catch (e) {
    console.warn('⚠️ Error reading localStorage, using initial data');
  }
  return [];
};

/**
 * بارگذاری آزمون‌ها از localStorage
 * @returns {Array} آرایه آزمون‌ها
 */
const loadExams = () => {
  try {
    const stored = localStorage.getItem('exams');
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed)) {
        // ✅ dedupe بر اساس id — آخرین نسخه (updatedAt/createdAt جدیدتر) می‌مونه
        const map = new Map();
        for (const e of parsed) {
          if (!e || typeof e !== 'object' || !e.id) continue;

          const isGlobal = e.isGlobal === true || e.isGlobal === 1 || e.isGlobal === 'true';
          const isChallenge = e.isChallenge === true || e.isChallenge === 1 || e.isChallenge === 'true';
          const published = e.published === true || e.published === 1 || e.published === 'true' || e.statusType === 'active';

          const normalized = {
            ...e,
            isGlobal,
            isChallenge,
            published,
            statusType: e.statusType || (published ? 'active' : 'pending'),
            status: e.status || (published ? 'فعال' : 'در انتظار'),
          };

          const prev = map.get(e.id);
          if (!prev) {
            map.set(e.id, normalized);
          } else {
            const prevTime = new Date(prev.updatedAt || prev.createdAt || 0).getTime();
            const curTime = new Date(normalized.updatedAt || normalized.createdAt || 0).getTime();
            if (curTime >= prevTime) map.set(e.id, normalized);
          }
        }
        return [...map.values()];
      }
    }
  } catch (e) {
    console.error('❌ Error loading exams:', e);
  }
  return getInitialExams() || [];
};

/**
 * ذخیره آزمون‌ها در localStorage
 * @param {Array} exams - آرایه آزمون‌ها
 */
const saveExamsToStorage = (exams) => {
  try {
    localStorage.setItem('exams', JSON.stringify(exams));
  } catch (e) {
    console.error('❌ Error saving exams:', e);
  }
};

// ============================================================
// ✅ توابع همگام‌سازی آزمون‌ها با سرور
// ============================================================

/** ارسال یک آزمون به سرور — اگه روی سرور نبود، با POST می‌سازدش */
// ============================================================
// ✅ توابع همگام‌سازی آزمون‌ها با سرور
// ============================================================

// 🆕 Set ماژول‌سطح از IDهایی که می‌دانیم روی سرور وجود دارند.
// چون ExamProvider فقط یک بار در ریشه اپ mount می‌شود، این متغیر
// دقیقاً همان رفتار یک ref را دارد ولی برای توابع ماژول‌سطح قابل دسترسی است.
const serverExamIds = new Set();

/**
 * ارسال یک آزمون به سرور
 * — اگر بدانیم روی سرور وجود دارد → PUT (بدون ۴۰۴ در کنسول)
 * — اگر ندانیم یا نباشد → POST (آزمون ساخته می‌شود)
 * — fallback: اگر Set عقب مانده بود و PUT ۴۰۴ داد، POST می‌کنیم و Set را اصلاح می‌کنیم
 */
const syncExamToServer = async (exam) => {
  if (!exam || !exam.id) return;
  try {
    const isKnown = serverExamIds.has(exam.id);

    if (isKnown) {
      // روی سرور هست → PUT
      const res = await fetch(`${EXAM_API_BASE}/exams/${encodeURIComponent(exam.id)}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(exam),
      });

      // 🆕 fallback: اگر Set عقب مانده بود، POST کن و Set رو اصلاح کن
      if (res.status === 404) {
        serverExamIds.delete(exam.id);
        const res2 = await fetch(`${EXAM_API_BASE}/exams`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(exam),
        });
        if (res2.ok) serverExamIds.add(exam.id);
      }
    } else {
      // روی سرور نیست → POST
      const res = await fetch(`${EXAM_API_BASE}/exams`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(exam),
      });
      if (res.ok) serverExamIds.add(exam.id);
    }
  } catch (e) {
    console.warn('⚠️ syncExamToServer failed:', e.message);
  }
};

/** حذف یک آزمون از سرور */
const deleteExamFromServer = async (examId) => {
  if (!examId) return;
  try {
    await fetch(`${EXAM_API_BASE}/exams/${examId}`, { method: 'DELETE' });
    // 🆕 از Set هم حذف کن
    serverExamIds.delete(examId);
  } catch (e) {
    console.warn('⚠️ deleteExamFromServer failed:', e.message);
  }
};

/** دریافت همه آزمون‌ها از سرور (null = سرور در دسترس نیست) */
const fetchAllExamsFromServer = async () => {
  try {
    const res = await fetch(`${EXAM_API_BASE}/exams`);
    if (!res.ok) return null;
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch (e) {
    console.warn('⚠️ fetchAllExamsFromServer failed:', e.message);
    return null;
  }
};

/** دریافت یک آزمون از سرور */
const fetchExamFromServer = async (examId) => {
  if (!examId) return null;
  try {
    const res = await fetch(`${EXAM_API_BASE}/exams/${examId}`);
    if (!res.ok) return null;
    return await res.json();
  } catch (e) {
    return null;
  }
};

// ============================================================
// ===== کش و بررسی عضویت =====
// ============================================================

const membershipCache = new Map();
const membershipCacheTime = new Map();
const MEMBERSHIP_CACHE_TTL = 2000; // ۲ ثانیه



/**
 * بررسی عضویت کاربر در یک گروه
 * @param {string} userId - شناسه کاربر
 * @param {string} teamId - شناسه گروه
 * @returns {boolean} وضعیت عضویت
 */
const isUserMemberOfTeam = (userId, teamId) => {
  if (!userId || !teamId) return false;
  
    const cacheKey = `${userId}-${teamId}`;
  const cachedAt = membershipCacheTime.get(cacheKey);
  if (
    membershipCache.has(cacheKey) &&
    cachedAt &&
    (Date.now() - cachedAt) < MEMBERSHIP_CACHE_TTL
  ) {
    return membershipCache.get(cacheKey);
  }

  let isMember = false;

  try {
    const storedMembers = localStorage.getItem('teamMembers');
    if (storedMembers) {
      const members = JSON.parse(storedMembers);
              isMember = members.some(
      (m) => idsEqual(m.studentId, userId) && idsEqual(m.teamId, teamId) && m.status === 'active'
    );
      if (isMember) {
        membershipCache.set(cacheKey, true);
        membershipCacheTime.set(cacheKey, Date.now());
        return true;
      }
    }
  } catch (e) {
    console.warn('⚠️ Error checking membership from teamMembers:', e);
  }

  try {
    const storedTeam = localStorage.getItem('team');
    if (storedTeam) {
            const team = JSON.parse(storedTeam);
      if (team && idsEqual(team.id, teamId) && idsEqual(team.teacherId, userId)) {
        membershipCache.set(cacheKey, true);
        membershipCacheTime.set(cacheKey, Date.now());
        return true;
      }
    }
  } catch (e) {
    console.warn('⚠️ Error checking team from localStorage:', e);
  }

  try {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const user = JSON.parse(storedUser);
      if (user.role === 'teacher' && user.id === userId) {
        membershipCache.set(cacheKey, true);
        membershipCacheTime.set(cacheKey, Date.now());
        return true;
      }
    }
  } catch (e) {
    console.warn('⚠️ Error checking user from localStorage:', e);
  }

  membershipCache.set(cacheKey, false);
  membershipCacheTime.set(cacheKey, Date.now());
  return false;
};

// ============================================================
// ===== توابع محاسبه نمره سوالات =====
// ============================================================

/**
 * محاسبه نمره یک سوال بر اساس پاسخ کاربر
 * @param {Object} question - شی سوال
 * @param {any} answer - پاسخ کاربر
 * @returns {number|null} نمره سوال یا null برای سوالات تشریحی
 */
const calculateQuestionScore = (question, answer) => {
  const score = toNumber(question.score, 1);
  const type = question.type;

  switch (type) {
    case 'multiple':
    case 'truefalse':
      return answer === question.correctAnswer ? score : 0;

    case 'multi': {
      const correct = question.correctAnswers || [];
      const user = Array.isArray(answer) ? answer : [];
      const isCorrect =
        correct.length === user.length &&
        correct.every((c) => user.includes(c));
      return isCorrect ? score : 0;
    }

    case 'fill': {
      const correct = question.fillAnswers || [];
      const user = Array.isArray(answer) ? answer : [];
      const isCorrect =
        user.length === correct.length &&
        user.every(
          (u, i) => u?.trim().toLowerCase() === correct[i]?.trim().toLowerCase()
        );
      return isCorrect ? score : 0;
    }

    case 'matching': {
      const pairs = question.matchingPairs || [];
      let userPairs = {};
      if (Array.isArray(answer)) {
        answer.forEach((val, idx) => {
          if (val !== undefined && val !== null && val !== '') {
            userPairs[idx] = val;
          }
        });
      } else if (typeof answer === 'object' && answer !== null) {
        userPairs = answer;
      } else if (typeof answer === 'string') {
        try {
          const parsed = JSON.parse(answer);
          userPairs = typeof parsed === 'object' && parsed !== null ? parsed : {};
        } catch {
          userPairs = {};
        }
      }
      const isCorrect = pairs.every((_, i) => {
        const userValue = userPairs[i];
        return userValue !== undefined && userValue !== null && userValue === i;
      });
      return isCorrect ? score : 0;
    }

    case 'ordering': {
      let userOrder = [];
      if (Array.isArray(answer)) {
        userOrder = answer;
      } else if (typeof answer === 'string') {
        try {
          const parsed = JSON.parse(answer);
          userOrder = Array.isArray(parsed) ? parsed : [];
        } catch {
          userOrder = [];
        }
      }
      const isCorrect = userOrder.every((val, i) => val === i);
      return isCorrect ? score : 0;
    }

    case 'essay':
    case 'file':
      return null;

    default:
      return 0;
  }
};

/**
 * استخراج پاسخ کاربر از ساختار پاسخ
 * @param {Object} question - شی سوال
 * @param {Object} answer - پاسخ کاربر
 * @returns {any} پاسخ استخراج شده
 */
const extractUserAnswer = (question, answer) => {
  if (!answer) return null;
  
  try {
    if (question.type === 'matching' || question.type === 'ordering') {
      if (typeof answer.text === 'string') {
        return JSON.parse(answer.text);
      }
      return answer.text || answer;
    }
    return answer.text !== undefined ? answer.text : answer;
  } catch {
    return answer.text || answer;
  }
};

// ============================================================
// ===== Context و Provider =====
// ============================================================

const ExamContext = createContext();

// 🆕 helper
const isStepQuiz = (e) => e?.isStepQuiz === true;

// 🆕 نسخه‌ی اختیاری برای استفاده در hook های BooksEngine
export const useExamsOptional = () => useContext(ExamContext);

export const ExamProvider = ({ children }) => {
  const [exams, setExams] = useState(loadExams);
  const [isInitialized, setIsInitialized] = useState(false);
  const saveTimeoutRef = useRef(null);

  // ✅ Refs برای همگام‌سازی با سرور
  const examsRef = useRef(exams);
  const syncTimeoutsRef = useRef({});
  const isServerReadyRef = useRef(false);
  const initStartedRef = useRef(false);

  // 🆕 نگهبان: جلوگیری از سیل ساخت آزمون
  const addCountRef = useRef({ count: 0, windowStart: Date.now() });

  // همیشه جدیدترین exams رو در ref نگه دار
  useEffect(() => {
    examsRef.current = exams;
  }, [exams]);

  // ✅ صف‌بندی همگام‌سازی با debounce
  const queueExamSync = useCallback((examId) => {
    if (!examId) return;
    if (syncTimeoutsRef.current[examId]) {
      clearTimeout(syncTimeoutsRef.current[examId]);
    }
    syncTimeoutsRef.current[examId] = setTimeout(async () => {
      delete syncTimeoutsRef.current[examId];
      const currentExam = examsRef.current.find((e) => e.id === examId);
      if (currentExam) {
        await syncExamToServer(currentExam);
      } else {
        await deleteExamFromServer(examId);
      }
    }, 500);
  }, []);

  // ✅ همگام‌سازی هوشمند نتایج (fetch-merge-patch برای جلوگیری از race condition)
  const queueExamResultsSync = useCallback((examId, studentResult) => {
    if (!examId) return;
    setTimeout(async () => {
      try {
        const localExam = examsRef.current.find((e) => e.id === examId);
        if (!localExam) return;

        const serverExam = await fetchExamFromServer(examId);
        if (!serverExam) {
          await syncExamToServer(localExam);
          return;
        }

        const serverResults = Array.isArray(serverExam.results) ? serverExam.results : [];
        const mergedResults = [...serverResults];
        const existingIdx = mergedResults.findIndex(
          (r) => String(r.studentId) === String(studentResult.studentId)
        );

        const localResult = localExam.results.find(
          (r) => String(r.studentId) === String(studentResult.studentId)
        );

        if (existingIdx >= 0) {
          if (localResult) mergedResults[existingIdx] = localResult;
        } else if (localResult) {
          mergedResults.push(localResult);
        }

        const finalExam = { ...serverExam, ...localExam, results: mergedResults };
        await syncExamToServer(finalExam);
      } catch (e) {
        console.warn('⚠️ queueExamResultsSync failed:', e.message);
      }
    }, 300);
  }, []);

  // ===== ذخیره خودکار =====
  useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true);
      return;
    }

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
    }

    saveTimeoutRef.current = setTimeout(() => {
      saveExamsToStorage(exams);
    }, 300);

        return () => {
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current);
      }
    };
  }, [exams, isInitialized]);

  // ============================================================
  // ✅ همگام‌سازی اولیه با سرور (در بار اول mount)
  // ============================================================
  useEffect(() => {
  const initFromServer = async () => {
    // ✅ گارد سنکرون: در StrictMode و هر جای دیگه فقط یک بار اجرا می‌شه
    if (initStartedRef.current) return;
    initStartedRef.current = true;

    const localExams = loadExams();
    const serverExams = await fetchAllExamsFromServer();

    // حالت ۱: سرور در دسترس نیست → فقط localStorage
    if (serverExams === null) {
      console.log('📴 Server unreachable → using localStorage only');
      isServerReadyRef.current = true;
      return;
    }

    // 🆕 Set رو از پاسخ سرور پر کن (قبل از هر تصمیمی — لازم برای POST/PUT درست)
    serverExamIds.clear();
    serverExams.forEach((e) => serverExamIds.add(e.id));

    // حالت ۲: سرور خالی، localStorage پر → آپلود کن
    if (serverExams.length === 0 && localExams.length > 0) {
      console.log(`📤 Uploading ${localExams.length} local exams to server...`);
      for (const e of localExams) {
        await syncExamToServer(e);   // Set خالی است → POST می‌زند
      }
      isServerReadyRef.current = true;
      return;
    }

    // حالت ۳: هر دو پر → merge (سرور اولویت، لوکال‌های انحصاری حفظ می‌شن)
    if (serverExams.length > 0) {
      const serverIds = new Set(serverExams.map((e) => e.id));
      const localOnly = localExams.filter((e) => !serverIds.has(e.id));
      const merged = [...serverExams, ...localOnly];

      console.log(`📥 Loaded ${serverExams.length} from server, ${localOnly.length} local-only`);

      setExams(merged);
      saveExamsToStorage(merged);

      for (const e of localOnly) {
        await syncExamToServer(e);
      }
    }

    isServerReadyRef.current = true;
  };

  initFromServer();
}, []);

  // ============================================================
  // ✅ رفرش دوره‌ای از سرور (برای دیدن آزمون‌های جدید سایر مرورگرها)
  // ============================================================
  useEffect(() => {

    const refreshFromServer = async () => {
      if (!isServerReadyRef.current) return;
      if (document.visibilityState !== 'visible') return;

      const serverExams = await fetchAllExamsFromServer();
      if (!serverExams) return;

      // 🆕 هر چیزی که روی سرور هست رو به Set اضافه کن (Set فقط رشد می‌کنه)
      serverExams.forEach((e) => serverExamIds.add(e.id));

      setExams((prev) => {
        const serverIds = new Set(serverExams.map((e) => e.id));
        const localOnly = prev.filter((e) => !serverIds.has(e.id));
        const merged = [...serverExams, ...localOnly];

        // 🆕 فقط اگه تعداد یا محتوای IDها فرق داشت، state رو عوض کن (بدون JSON.stringify)
        if (merged.length === prev.length && localOnly.length === 0) {
          const prevIdSet = new Set(prev.map((e) => e.id));
          let sameIds = true;
          for (const se of serverExams) {
            if (!prevIdSet.has(se.id)) { sameIds = false; break; }
          }
          if (sameIds) return prev;   // ← دیگه stringify نمی‌کنیم، فقط IDها رو چک می‌کنیم
        }

        console.log(`🔄 Refreshed from server: ${serverExams.length} exams`);
        return merged;
      });
    };

    // 🆕 فقط روی focus و visibilitychange رفرش کن — نه هر ۱۰ ثانیه
    const onFocus = () => refreshFromServer();
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') refreshFromServer();
    };

    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  // ✅ Cleanup تایمرهای sync هنگام unmount
  useEffect(() => {
    const timeouts = syncTimeoutsRef.current;
    return () => {
      Object.values(timeouts).forEach(clearTimeout);
    };
  }, []);

  // ============================================================
  // ===== مقداردهی اولیه نتایج غایب =====
  // ============================================================
  const initializeAbsentResults = useCallback(() => {
    const storedUser = localStorage.getItem('user');
    const user = storedUser ? JSON.parse(storedUser) : null;
    if (!user || user.role !== 'student') return;

    const studentId = user.id;
    let hasChanges = false;

    setExams((prevExams) => {
      const updatedExams = prevExams.map((exam) => {
        if (exam.isGlobal) return exam;
        if (exam.statusType !== 'closed') return exam;
        
        const hasResult = exam.results?.some((r) => r.studentId === studentId);
        if (hasResult) return exam;

        const absentResult = {
          studentId: studentId,
          score: 0,
          answers: [],
          isEssayGraded: true,
          submittedAt: new Date().toISOString(),
          details: [],
          isFinalSubmit: true,
          isCompleted: true,
          isAbsent: true,
        };

        hasChanges = true;
        return {
          ...exam,
          results: [...(exam.results || []), absentResult],
          participants: (exam.participants || 0) + 1,
        };
      });

      return updatedExams;
    });

    return hasChanges;
  }, []);

  // ===== اجرای مقداردهی اولیه نتایج غایب =====
  useEffect(() => {
    if (!isInitialized) return;
    const timeout = setTimeout(() => {
      initializeAbsentResults();
    }, 500);
    return () => clearTimeout(timeout);
  }, [isInitialized, initializeAbsentResults]);

  // ============================================================
  // ===== ۱. اضافه کردن آزمون (با پشتیبانی از عمومی و چالش) =====
  // ============================================================
  const addExam = useCallback((exam) => {
    if (!exam) {
      console.error('❌ addExam: exam data is required');
      return null;
    }

    // 🆕 نگهبان: جلوگیری از سیل ساخت آزمون
    const now = Date.now();
    if (now - addCountRef.current.windowStart > 5000) {
      addCountRef.current = { count: 0, windowStart: now };
    }
    addCountRef.current.count++;

    if (addCountRef.current.count > 30) {
      console.error('🚨 بیش از ۳۰ آزمون در ۵ ثانیه — احتمال حلقه!');
      console.trace('محل صدا زدن addExam:');
    }
    if (addCountRef.current.count > 200) {
      console.error('🛑 بیش از ۲۰۰ آزمون — متوقف شد.');
      return null;
    }

    // اگر آزمون عمومی است، بررسی دسترسی ادمین ویژه
    if (exam.isGlobal) {
      const currentUserId = exam.teacherId || localStorage.getItem('userId');
      if (!isGlobalAdmin(currentUserId)) {
        console.error('❌ فقط ادمین‌های ویژه می‌توانند آزمون عمومی بسازند');
        alert('❌ فقط ادمین‌های ویژه می‌توانند آزمون عمومی بسازند.');
        return null;
      }
    }

    let teamId = exam.teamId || null;
    let teacherId = exam.teacherId || null;

    // اگر آزمون عمومی است، نیازی به گروه ندارد
    if (!exam.isGlobal) {
      if (!teamId) {
        try {
          const storedTeam = localStorage.getItem('team');
          if (storedTeam) {
            const team = JSON.parse(storedTeam);
            if (team?.id) teamId = team.id;
          }
        } catch (e) {
          console.warn('⚠️ Error reading team:', e);
        }
      }
    }

    if (!teacherId) {
      try {
        const uid = localStorage.getItem('userId');
        if (uid) teacherId = uid;
      } catch (e) {
        console.warn('⚠️ Error reading user:', e);
      }
    }

    let totalStudents = exam.totalStudents || 0;
    if (!totalStudents && teamId && !exam.isGlobal) {
      try {
        const storedMembers = localStorage.getItem('teamMembers');
        if (storedMembers) {
          const members = JSON.parse(storedMembers);
          totalStudents = members.filter((m) => m.teamId === teamId && m.status === 'active').length;
        }
      } catch (e) {
        console.warn('⚠️ Error counting team members:', e);
      }
    }

        const newExam = {
      ...exam,
      id: exam.id || generateId(),
      results: [],
      participants: 0,
      totalStudents: exam.isGlobal ? 0 : (totalStudents || 0),
      status: exam.published ? 'فعال' : 'در انتظار',
      statusType: exam.published ? 'active' : 'pending',
      teamId: exam.isGlobal ? null : teamId,
      teacherId: teacherId,
      date: exam.date || null,
      // فیلدهای جدید برای آزمون‌های عمومی
      isGlobal: exam.isGlobal || false,
      grade: exam.grade || '',
      field: exam.field ? (curriculumNormalizeField(exam.field) || null) : null,   // 🔽 CHANGED
      subject: exam.subject || '',
      book: exam.book || '',
      chapter: exam.chapter || '',
      // فیلدهای قبلی
      shuffleQuestions: exam.shuffleQuestions || false,
      shuffleOptions: exam.shuffleOptions || false,
      showResult: exam.showResult !== undefined ? exam.showResult : true,
      showCorrectAnswers: exam.showCorrectAnswers || false,
      limitAttempts: exam.limitAttempts || 1,
      displayMode: exam.displayMode || 'step',
      startTime: exam.startTime || null,
      endTime: exam.endTime || null,
      ipRestriction: exam.ipRestriction || null,
      image: exam.image || null,
      description: exam.description || '',
      class: exam.class || '',
      createdAt: exam.createdAt || new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      archivedAt: null,
      
      coinsNeedsWork: exam.coinsNeedsWork || 0,    // جدید
  xpNeedsWork: exam.xpNeedsWork || 0,          // جدید
  coinsUnacceptable: exam.coinsUnacceptable || 0, // جدید
  xpUnacceptable: exam.xpUnacceptable || 0,    // جدید
  coinsFailed: exam.coinsFailed || 0,          // جدید
  xpFailed: exam.xpFailed || 0,                // جدید
  coinsExcellent: exam.coinsExcellent || 0,
  xpExcellent: exam.xpExcellent || 0,
  coinsVeryGood: exam.coinsVeryGood || 0,
  xpVeryGood: exam.xpVeryGood || 0,
  coinsGood: exam.coinsGood || 0,
  xpGood: exam.xpGood || 0,

  // 🆕 Badge controls (admin only)
  requiredCoins: toNumber(exam.requiredCoins, 0),
  forceNew: exam.forceNew === true,
  forceHot: exam.forceHot === true,
  newBadgeDuration: toNumber(exam.newBadgeDuration, 24),
  hotThresholdParticipants: toNumber(exam.hotThresholdParticipants, 1000),
  hotThresholdRecentResults: toNumber(exam.hotThresholdRecentResults, 100),
    };

       setExams((prev) => [...prev, newExam]);

    // ✅ همگام‌سازی با سرور
    queueExamSync(newExam.id);

    return newExam;
  }, [queueExamSync]);

  // ============================================================
  // ===== ۲. به‌روزرسانی آزمون (با چک دسترسی برای عمومی) =====
  // ============================================================
  const updateExam = useCallback((examId, updatedData) => {
    if (!examId) {
      console.error('❌ updateExam: examId is required');
      return null;
    }

    let updatedExam = null;

    setExams((prev) => {
      const examIndex = prev.findIndex((e) => e.id === examId);
      if (examIndex === -1) {
        console.warn(`⚠️ Exam with id ${examId} not found`);
        return prev;
      }

      const exam = prev[examIndex];
      
      // اگر آزمون عمومی است یا در حال تبدیل به عمومی است، بررسی دسترسی ادمین
      {/*if (exam.isGlobal || updatedData.isGlobal) {
        const storedUser = localStorage.getItem('user');
        const user = storedUser ? JSON.parse(storedUser) : null;
        if (!isGlobalAdmin(user?.id)) {
          console.error('❌ فقط ادمین‌های ویژه می‌توانند آزمون عمومی را ویرایش کنند');
          alert('❌ فقط ادمین‌های ویژه (hhh123 و hhh1234) می‌توانند آزمون عمومی را ویرایش کنند.');
          return prev;
        }
      }*/}

            updatedExam = {
        ...exam,
        ...updatedData,
        id: exam.id,
        // اگر عمومی است، teamId را null می‌کنیم
        teamId: updatedData.isGlobal ? null : (updatedData.teamId || exam.teamId),
        // 🔽 CHANGED: نرمال‌سازی فیلد
        field: updatedData.field !== undefined
          ? (updatedData.field ? (curriculumNormalizeField(updatedData.field) || null) : null)
          : (exam.field || null),
        updatedAt: new Date().toISOString(),


      coinsExcellent: updatedData.coinsExcellent !== undefined ? updatedData.coinsExcellent : (exam.coinsExcellent || 0),
      xpExcellent: updatedData.xpExcellent !== undefined ? updatedData.xpExcellent : (exam.xpExcellent || 0),
      coinsVeryGood: updatedData.coinsVeryGood !== undefined ? updatedData.coinsVeryGood : (exam.coinsVeryGood || 0),
      xpVeryGood: updatedData.xpVeryGood !== undefined ? updatedData.xpVeryGood : (exam.xpVeryGood || 0),
      coinsGood: updatedData.coinsGood !== undefined ? updatedData.coinsGood : (exam.coinsGood || 0),
      xpGood: updatedData.xpGood !== undefined ? updatedData.xpGood : (exam.xpGood || 0),
      coinsNeedsWork: updatedData.coinsNeedsWork !== undefined ? updatedData.coinsNeedsWork : (exam.coinsNeedsWork || 0),
      xpNeedsWork: updatedData.xpNeedsWork !== undefined ? updatedData.xpNeedsWork : (exam.xpNeedsWork || 0),
      coinsUnacceptable: updatedData.coinsUnacceptable !== undefined ? updatedData.coinsUnacceptable : (exam.coinsUnacceptable || 0),
      xpUnacceptable: updatedData.xpUnacceptable !== undefined ? updatedData.xpUnacceptable : (exam.xpUnacceptable || 0),
      coinsFailed: updatedData.coinsFailed !== undefined ? updatedData.coinsFailed : (exam.coinsFailed || 0),
      xpFailed: updatedData.xpFailed !== undefined ? updatedData.xpFailed : (exam.xpFailed || 0),

      // 🆕 Badge controls (admin only)
      requiredCoins: updatedData.requiredCoins !== undefined
        ? toNumber(updatedData.requiredCoins, 0)
        : (exam.requiredCoins || 0),
      forceNew: updatedData.forceNew !== undefined
        ? updatedData.forceNew === true
        : (exam.forceNew === true),
      forceHot: updatedData.forceHot !== undefined
        ? updatedData.forceHot === true
        : (exam.forceHot === true),
      newBadgeDuration: updatedData.newBadgeDuration !== undefined
        ? toNumber(updatedData.newBadgeDuration, 24)
        : (exam.newBadgeDuration ?? 24),
      hotThresholdParticipants: updatedData.hotThresholdParticipants !== undefined
        ? toNumber(updatedData.hotThresholdParticipants, 1000)
        : (exam.hotThresholdParticipants ?? 1000),
      hotThresholdRecentResults: updatedData.hotThresholdRecentResults !== undefined
        ? toNumber(updatedData.hotThresholdRecentResults, 100)
        : (exam.hotThresholdRecentResults ?? 100),
    };

      const newExams = [...prev];
      newExams[examIndex] = updatedExam;
      return newExams;
    });

    // ✅ همگام‌سازی با سرور
    if (updatedExam?.id) queueExamSync(updatedExam.id);

    return updatedExam;
  }, [queueExamSync]);

  // ============================================================
  // ===== ۳. به‌روزرسانی نتایج (با وضعیت جداگانه برای هر دانش‌آموز) =====
  // ============================================================
const updateExamResults = useCallback((examId, studentResult) => {
    if (!examId || !studentResult?.studentId) {
      console.error('❌ updateExamResults: examId and studentId are required');
      return null;
    }

    let updatedExam = null;

    setExams((prev) =>
      prev.map((exam) => {
        if (exam.id !== examId) return exam;

        // 🆕 Step Quizzes: نتایج در BooksEngine ذخیره می‌شوند، نه اینجا
        // فقط وضعیت quiz را به‌روزرسانی کن (برای preview معلم)
        if (exam.isStepQuiz === true) {
          // فقط برای audit trail — نتایج واقعی در progressManager هستند
          return {
            ...exam,
            updatedAt: new Date().toISOString(),
          };
        }

        // ... بقیه کد قبلی بدون تغییر

        const existingResults = exam.results?.filter(
          (r) => idsEqual(r.studentId, studentResult.studentId)
        ) || [];
        const limit = exam.limitAttempts || 1;
        
        if (existingResults.length >= limit) {
          console.warn(`⚠️ Student ${studentResult.studentId} has already attempted this exam ${limit} times`);
          return exam;
        }

        const existingIndex = exam.results?.findIndex(
          (r) => idsEqual(r.studentId, studentResult.studentId)
        ) ?? -1;

        const newResults = [...(exam.results || [])];

        const hasEssay = exam.questions?.some(
          (q) => q.type === 'essay' || q.type === 'file'
        ) ?? false;

        const isEssayGraded = studentResult.isEssayGraded !== undefined
          ? studentResult.isEssayGraded
          : !hasEssay;

        const existingResult = existingIndex >= 0 ? newResults[existingIndex] : null;
        const existingAnswers = existingResult?.answers || [];

        const normalizedAnswers = (studentResult.answers || []).map((ans) => ({
          questionId: ans.questionId || ans.id || null,
          questionIndex: ans.questionIndex !== undefined ? ans.questionIndex : null,
          text: ans.text || ans.userAnswer || '',
          isCorrect: ans.isCorrect !== undefined ? ans.isCorrect : null,
          type: ans.type || 'essay',
        }));

        const finalAnswers = normalizedAnswers.length > 0 ? normalizedAnswers : existingAnswers;

        const fullResult = {
          studentId: studentResult.studentId,
          score: toNumber(studentResult.score),
          answers: finalAnswers,
          isEssayGraded: isEssayGraded,
          correctedDetails: studentResult.correctedDetails || [],
          submittedAt: studentResult.submittedAt || new Date().toISOString(),
          details: studentResult.details || [],
          isFinalSubmit: studentResult.isFinalSubmit || false,
          // ✅ اضافه کردن وضعیت اختصاصی برای این دانش‌آموز
          isCompleted: studentResult.isFinalSubmit || false,
        };

        if (existingIndex >= 0) {
          newResults[existingIndex] = {
            ...existingResult,
            ...fullResult,
          };
        } else {
          newResults.push(fullResult);
        }

        // ===== وضعیت کلی آزمون (برای نمایش در صفحه معلم) =====
        const hasEssayQuestions = exam.questions?.some(
          (q) => q.type === 'essay' || q.type === 'file'
        ) ?? false;
        const totalStudents = exam.totalStudents || 0;
        const allParticipated = totalStudents > 0 && newResults.length >= totalStudents;
        const now = new Date();
        const endTime = exam.endTime ? new Date(exam.endTime) : null;
        const isPastEndTime = endTime && now > endTime;
        const allGraded = newResults.every((r) => r.isEssayGraded !== false);

        let newStatusType, newStatus;

        // ===== محاسبه وضعیت کلی =====
        if (hasEssayQuestions) {
          if (!allGraded) {
            newStatusType = 'correction';
            newStatus = 'نیاز به تصحیح';
          } else {
            newStatusType = 'closed';
            newStatus = 'بسته شده';
          }
        } else {
          if (allParticipated || isPastEndTime) {
            newStatusType = 'closed';
            newStatus = 'بسته شده';
          } else {
            newStatusType = 'active';
            newStatus = 'فعال';
          }
        }

      updatedExam = {
        ...exam,
        results: newResults,
        participants: newResults.length,
        statusType: newStatusType,
        status: newStatus,
        updatedAt: new Date().toISOString(),
      };

      return updatedExam;
      })
    );

    // ✅ همگام‌سازی هوشمند با سرور (fetch-merge-patch)
    if (updatedExam?.id) {
      queueExamResultsSync(updatedExam.id, studentResult);
    }

    return updatedExam;
  }, [queueExamResultsSync]);

  // ============================================================
  // ===== ۴. به‌روزرسانی وضعیت تصحیح =====
  // ============================================================
  const updateCorrectionStatus = useCallback((examId, studentId, correctedScore) => {
    if (!examId || !studentId) {
      console.error('❌ updateCorrectionStatus: examId and studentId are required');
      return null;
    }

    let updatedExam = null;

    setExams((prev) =>
      prev.map((exam) => {
        if (exam.id !== examId) return exam;

        const newResults = (exam.results || []).map((r) => {
          if (r.studentId === studentId) {
            return {
              ...r,
              score: correctedScore !== undefined ? correctedScore : r.score,
              isEssayGraded: true,
            };
          }
          return r;
        });

        const hasEssayQuestions = exam.questions?.some(
          (q) => q.type === 'essay' || q.type === 'file'
        ) ?? false;
        const allGraded = newResults.every((r) => r.isEssayGraded !== false);

        let newStatusType, newStatus;

        if (hasEssayQuestions && !allGraded) {
          newStatusType = 'correction';
          newStatus = 'نیاز به تصحیح';
        } else if (hasEssayQuestions && allGraded) {
          newStatusType = 'closed';
          newStatus = 'بسته شده';
        } else {
          newStatusType = 'active';
          newStatus = 'فعال';
        }

        updatedExam = {
          ...exam,
          results: newResults,
          statusType: newStatusType,
          status: newStatus,
          updatedAt: new Date().toISOString(),
        };

        return updatedExam;
      })
    );

    // ✅ همگام‌سازی با سرور
    if (updatedExam?.id) queueExamSync(updatedExam.id);

    return updatedExam;
  }, [queueExamSync]);

  // ============================================================
  // ===== ۵. حذف آزمون (با چک دسترسی برای عمومی) =====
  // ============================================================
  const deleteExam = useCallback(async (examId) => {
  if (!examId) {
    console.error('❌ deleteExam: examId is required');
    return false;
  }

  const examToDelete = exams.find((e) => e.id === examId);
  if (!examToDelete) return false;

  // ===== حذف تصاویر از سرور =====
  try {
    if (examToDelete.teacherId && examId) {
      await deleteExamImages(examToDelete.teacherId, examId);
    }
    // همچنین تصویر شاخص را حذف کن
    if (examToDelete.image) {
      await deleteImage(examToDelete.image);
    }
    // تصاویر سوالات به همراه پوشه کل آزمون حذف می‌شوند
  } catch (e) {
    console.warn('Error deleting images:', e);
  }

    setExams((prev) => prev.filter((e) => e.id !== examId));

    // ✅ حذف از سرور
    deleteExamFromServer(examId);

    return true;
  }, [exams]);

  // ============================================================
  // ===== ۶. کپی آزمون (با چک دسترسی برای عمومی) =====
  // ============================================================
  const duplicateExam = useCallback((examId) => {
    let success = false;

    setExams((prev) => {
      const exam = prev.find((e) => e.id === examId);
      if (!exam) {
        console.warn(`⚠️ Exam with id ${examId} not found for duplication`);
        return prev;
      }

      // اگر آزمون عمومی است، بررسی دسترسی ادمین
      if (exam.isGlobal) {
        const storedUser = localStorage.getItem('user');
        const user = storedUser ? JSON.parse(storedUser) : null;
        if (!isGlobalAdmin(user?.id)) {
          console.error('❌ فقط ادمین‌های ویژه می‌توانند آزمون عمومی را کپی کنند');
          alert('❌ فقط ادمین‌های ویژه (hhh123 و hhh1234) می‌توانند آزمون عمومی را کپی کنند.');
          return prev;
        }
      }

      const newExam = {
        ...exam,
        id: generateId(),
        title: `${exam.title} (کپی)`,
        results: [],
        participants: 0,
        status: 'در انتظار',
        statusType: 'pending',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        archivedAt: null,
      };

      success = true;
      return [...prev, newExam];
    });

    // ✅ همگام‌سازی با سرور بعد از کپی (کمی تأخیر برای اطمینان از آپدیت state)
    setTimeout(() => {
      const latest = examsRef.current;
      if (latest.length > 0) {
        const newest = latest[latest.length - 1];
        if (newest?.id) queueExamSync(newest.id);
      }
    }, 100);

    return success;
  }, [queueExamSync]);

  // ============================================================
  // ===== ۷. دریافت آزمون =====
  // ============================================================
  const getExam = useCallback((examId) => {
    if (!examId) return null;
    return exams.find((e) => e.id === examId) || null;
  }, [exams]);

  // ============================================================
  // ===== ۸. تعداد نیاز به تصحیح =====
  // ============================================================
  const getPendingCorrections = useCallback(() => {
    let count = 0;
    exams.forEach((exam) => {
      if (exam.statusType === 'correction') {
        (exam.results || []).forEach((r) => {
          if (r.isEssayGraded === false) {
            count++;
          }
        });
      }
    });
    return count;
  }, [exams]);

  // ============================================================
  // ===== ۹. آزمون‌های معلم (فقط آزمون‌های غیرعمومی) =====
  // ============================================================
const getExamsByTeacher = useCallback((teacherId) => {
  if (!teacherId) return [];
  return exams.filter((e) =>
    idsEqual(e.teacherId, teacherId) && !e.isGlobal && !isStepQuiz(e)
  );
}, [exams]);

  // ============================================================
  // ===== ۱۰. آزمون‌های گروه =====
  // ============================================================
// ✅ بعد
const getExamsByTeam = useCallback((teamId) => {
  if (!teamId) return [];
  return exams.filter(
    (e) =>
      e.teamId === teamId &&
      e.statusType !== 'archived' &&
      !e.isGlobal &&
      !isStepQuiz(e)
  );
}, [exams]);

  // ============================================================
  // ===== ۱۱. آزمون‌های دانش‌آموز (فقط active و correction) =====
  // ============================================================
    const getExamsForStudent = useCallback((teamId, userId) => {
    if (!teamId || !userId) return [];

    const isMember = isUserMemberOfTeam(userId, teamId);
    if (!isMember) return [];

    // پیدا کردن معلمِ این گروه (فقط برای fallback امن)
    let teamTeacherId = null;
    try {
      const storedTeam = localStorage.getItem('team');
      if (storedTeam) {
        const t = JSON.parse(storedTeam);
        if (t && t.id === teamId) {
          teamTeacherId = t.teacherId || t.createdBy || null;
        }
      }
      if (!teamTeacherId) {
        const storedMembers = localStorage.getItem('teamMembers');
        const storedUsers = localStorage.getItem('users');
        if (storedMembers && storedUsers) {
          const members = JSON.parse(storedMembers);
          const usersArr = JSON.parse(storedUsers);
          const teacherIds = usersArr
            .filter((u) =>
              u.role === 'teacher' || u.role === 'admin' || u.role === 'superadmin'
            )
            .map((u) => u.id);
          const m = members.find(
            (mm) =>
              mm.teamId === teamId &&
              teacherIds.includes(mm.studentId || mm.userId)
          );
          if (m) teamTeacherId = m.studentId || m.userId;
        }
      }
    } catch (e) {
      console.warn('⚠️ Error finding team teacher:', e);
    }

    return exams.filter((e) => {
      // 🚫 سه دسته‌ی جدا — هرگز قاطی نشوند
      if (e.isGlobal) return false;      // عمومی → اینجا نباشه
      if (e.isChallenge) return false;   // چالش → اینجا نباشه
      if (isStepQuiz(e)) return false;
      if (e.statusType === 'archived') return false;
      if (e.statusType !== 'active' && e.statusType !== 'correction') return false;

      // مسیر اصلی: تطبیق مستقیم teamId
            // مسیر اصلی: تطبیق مستقیم teamId
      // مسیر اصلی: تطبیق مستقیم teamId
      if (idsEqual(e.teamId, teamId)) return true;

      // fallback امن: آزمون گروهی که teamId نداره ولی مال معلمِ همین گروهه
      // ⚠️ شرط «!e.isGlobal && !e.isChallenge» بالا تضمین می‌کنه که
      //    این fallback هرگز آزمون عمومی یا چالش رو نشون نده.
      if (
        (!e.teamId || e.teamId === 'no-group') &&
        teamTeacherId &&
        idsEqual(e.teacherId, teamTeacherId)
      ) {
        console.warn('⚠️ Group exam with null teamId shown via teacher fallback:', e.id, e.title);
        return true;
      }

      return false;
    });
  }, [exams]);

  // ============================================================
  // ===== ۱۲. نتیجه دانش‌آموز =====
  // ============================================================
  const getStudentResult = useCallback((examId, studentId) => {
    if (!examId || !studentId) return null;
    const exam = getExam(examId);
    if (!exam) return null;
    return exam.results?.find((r) => idsEqual(r.studentId, studentId)) || null;
  }, [getExam]);

  // ============================================================
  // ===== ۱۳. تمام نتایج دانش‌آموز =====
  // ============================================================
  const getStudentAllResults = useCallback((studentId) => {
    if (!studentId) return [];
    const allResults = [];
    exams.forEach((exam) => {
      const result = exam.results?.find((r) => r.studentId === studentId);
      if (result) {
        allResults.push({
          examId: exam.id,
          examTitle: exam.title,
          ...result,
        });
      }
    });
    return allResults;
  }, [exams]);

  // ============================================================
  // ===== ۱۴. آمار (فقط آزمون‌های غیرعمومی) =====
  // ============================================================
const getExamStats = useCallback(() => {
  const nonGlobal = exams.filter((e) => !e.isGlobal && !isStepQuiz(e));
    return {
      total: nonGlobal.length,
      active: nonGlobal.filter((e) => e.statusType === 'active').length,
      pending: nonGlobal.filter((e) => e.statusType === 'pending').length,
      closed: nonGlobal.filter((e) => e.statusType === 'closed').length,
      correction: nonGlobal.filter((e) => e.statusType === 'correction').length,
      archived: nonGlobal.filter((e) => e.statusType === 'archived').length,
    };
  }, [exams]);

  // ============================================================
  // ===== ۱۵. آرشیو (با چک دسترسی برای عمومی) =====
  // ============================================================
  const archiveExam = useCallback((examId) => {
    if (!examId) {
      console.error('❌ archiveExam: examId is required');
      return null;
    }

    const examToArchive = exams.find((e) => e.id === examId);
    if (!examToArchive) return null;

    if (examToArchive?.isGlobal) {
      const storedUser = localStorage.getItem('user');
      const user = storedUser ? JSON.parse(storedUser) : null;
      if (!isGlobalAdmin(user?.id)) {
        console.error('❌ فقط ادمین‌های ویژه می‌توانند آزمون عمومی را بایگانی کنند');
        alert('❌ فقط ادمین‌های ویژه (hhh123 و hhh1234) می‌توانند آزمون عمومی را بایگانی کنند.');
        return null;
      }
    }

    // ✅ NEW: آبجکت نهایی رو قبل از setState بساز تا مقدار برگشتی معتبر باشه
    // و وضعیت قبلی رو هم حفظ کن برای بازیابی
    const archivedExam = {
      ...examToArchive,
      status: 'بایگانی شده',
      statusType: 'archived',
      previousStatus: examToArchive.status,
      previousStatusType: examToArchive.statusType,
      updatedAt: new Date().toISOString(),
      archivedAt: new Date().toISOString(),
    };

    setExams((prev) =>
      prev.map((exam) => (exam.id === examId ? archivedExam : exam))
    );

    // ✅ همگام‌سازی با سرور
    queueExamSync(archivedExam.id);

    return archivedExam;
  }, [exams, queueExamSync]);

  // ============================================================
  // ===== ۱۶. بازیابی =====
  // ============================================================
  const restoreExam = useCallback((examId) => {
    if (!examId) {
      console.error('❌ restoreExam: examId is required');
      return null;
    }

    const examToRestore = exams.find((e) => e.id === examId);
    if (!examToRestore) return null;

    // ✅ NEW: از previousStatus که هنگام آرشیو ذخیره کردیم استفاده کن
    const previousStatusType = examToRestore.previousStatusType || 'active';
    const previousStatus = examToRestore.previousStatus || 'فعال';

    const restoredExam = {
      ...examToRestore,
      status: previousStatus,
      statusType: previousStatusType,
      updatedAt: new Date().toISOString(),
      archivedAt: null,
      previousStatus: null,
      previousStatusType: null,
    };

    setExams((prev) =>
      prev.map((exam) => (exam.id === examId ? restoredExam : exam))
    );

    // ✅ همگام‌سازی با سرور
    queueExamSync(restoredExam.id);

    return restoredExam;
  }, [exams, queueExamSync]);

  // ============================================================
  // ===== ۱۷. بررسی عضویت =====
  // ============================================================
  const checkUserMembership = useCallback((userId, teamId) => {
    return isUserMemberOfTeam(userId, teamId);
  }, []);

  // ============================================================
  // ===== ۱۸. دریافت پاسخ‌های تشریحی =====
  // ============================================================
  const getEssayAnswers = useCallback((examId, studentId) => {
    if (!examId || !studentId) return [];

    const exam = getExam(examId);
    if (!exam) return [];

    const result = exam.results?.find((r) => r.studentId === studentId);
    if (!result) return [];

    const studentAnswers = result.answers || [];

    const answersMap = {};
    studentAnswers.forEach((ans) => {
      if (ans.questionId) {
        answersMap[ans.questionId] = ans;
      } else if (ans.questionIndex !== undefined && ans.questionIndex !== null) {
        const q = exam.questions?.[ans.questionIndex];
        if (q) {
          answersMap[q.id] = ans;
        }
      }
    });

    return (exam.questions || [])
      .map((q, idx) => ({ ...q, index: idx }))
      .filter((q) => q.type === 'essay' || q.type === 'file')
      .map((q) => {
        const answer = answersMap[q.id] || null;
        return {
          questionId: q.id,
          questionIndex: q.index,
          questionText: q.question || '',
          score: toNumber(q.score, 1),
          userAnswer: answer?.text || 'پاسخی ثبت نشده',
          isCorrect: answer?.isCorrect ?? null,
          isGraded: answer?.isCorrect !== undefined && answer?.isCorrect !== null,
        };
      });
  }, [getExam]);

  // ============================================================
  // ===== ۱۹. به‌روزرسانی تصحیح یک پاسخ =====
  // ============================================================
  const updateEssayCorrection = useCallback((examId, studentId, questionIndex, isCorrect) => {
    if (!examId || !studentId || questionIndex === undefined) {
      console.error('❌ updateEssayCorrection: examId, studentId, and questionIndex are required');
      return null;
    }

    let updatedExam = null;

    setExams((prev) =>
      prev.map((exam) => {
        if (exam.id !== examId) return exam;

        const newResults = (exam.results || []).map((r) => {
          if (r.studentId !== studentId) return r;

          const question = exam.questions?.[questionIndex];
          if (!question) return r;

          const answers = r.answers || [];
          let existingIdx = answers.findIndex(
            (a) => a.questionId === question.id || a.questionIndex === questionIndex
          );
          
          const newAnswers = [...answers];

          if (existingIdx >= 0) {
            newAnswers[existingIdx] = {
              ...newAnswers[existingIdx],
              questionId: question.id,
              questionIndex: questionIndex,
              isCorrect: isCorrect,
              type: question.type,
            };
          } else {
            newAnswers.push({
              questionId: question.id,
              questionIndex: questionIndex,
              text: '',
              isCorrect: isCorrect,
              type: question.type,
            });
          }

          return { ...r, answers: newAnswers };
        });

        updatedExam = {
          ...exam,
          results: newResults,
          updatedAt: new Date().toISOString(),
        };

        return updatedExam;
      })
    );

    return updatedExam;
  }, []);

  // ============================================================
  // ===== ۲۰. پردازش تصحیح (با بسته شدن خودکار) =====
  // ============================================================
  const processCorrection = useCallback((examId, studentId, corrections) => {
    if (!examId || !studentId || !Array.isArray(corrections)) {
      console.error('❌ processCorrection: پارامترهای نامعتبر');
      return null;
    }

    let updatedExam = null;
    let updatedResult = null;

    setExams((prev) => {
      const examIndex = prev.findIndex((e) => e.id === examId);
      if (examIndex === -1) return prev;

      const currentExam = prev[examIndex];
      const currentResult = currentExam.results?.find(
        (r) => r.studentId === studentId
      );
      if (!currentResult) return prev;

      let answers = [...(currentResult.answers || [])];

      corrections.forEach(({ questionIndex, isCorrect }) => {
        const question = currentExam.questions?.[questionIndex];
        if (!question) {
          console.warn(`⚠️ Question at index ${questionIndex} not found`);
          return;
        }

        const existingIdx = answers.findIndex(
          (a) => a.questionId === question.id
        );
        
        if (existingIdx >= 0) {
          answers[existingIdx] = {
            ...answers[existingIdx],
            isCorrect: isCorrect,
          };
        } else {
          answers.push({
            questionIndex: questionIndex,
            questionId: question.id,
            isCorrect: isCorrect,
            text: '',
            type: question.type || 'essay',
          });
        }
      });

      let finalScore = 0;
      let allEssayCorrected = true;

      (currentExam.questions || []).forEach((q, idx) => {
        const isEssay = q.type === 'essay' || q.type === 'file';
        const answer = answers.find(
          (a) => a.questionId === q.id
        );

        if (isEssay) {
          if (answer && answer.isCorrect === true) {
            finalScore += toNumber(q.score, 1);
          } else if (answer && answer.isCorrect === false) {
            // غلط: نمره نمی‌گیرد
          } else {
            allEssayCorrected = false;
          }
        } else {
          const userAnswer = extractUserAnswer(q, answer);
          const score = calculateQuestionScore(q, userAnswer);
          if (score !== null) {
            finalScore += score;
          }
        }
      });

      const newResult = {
        ...currentResult,
        answers: answers,
        score: finalScore,
        isEssayGraded: allEssayCorrected,
      };

      const newResults = (currentExam.results || []).map((r) =>
        r.studentId === studentId ? newResult : r
      );

      const hasEssayQuestions = currentExam.questions?.some(
        (q) => q.type === 'essay' || q.type === 'file'
      ) ?? false;
      const allGraded = newResults.every((r) => r.isEssayGraded !== false);

      // ===== تعیین وضعیت جدید =====
      let newStatusType, newStatus;

      if (hasEssayQuestions && !allGraded) {
        newStatusType = 'correction';
        newStatus = 'نیاز به تصحیح';
      } else if (hasEssayQuestions && allGraded) {
        newStatusType = 'closed';
        newStatus = 'بسته شده';
      } else {
        newStatusType = 'active';
        newStatus = 'فعال';
      }

      updatedExam = {
        ...currentExam,
        results: newResults,
        statusType: newStatusType,
        status: newStatus,
        updatedAt: new Date().toISOString(),
      };
      updatedResult = newResult;

      const newExams = [...prev];
      newExams[examIndex] = updatedExam;
      return newExams;
    });

    if (!updatedExam || !updatedResult) return null;

    // ✅ همگام‌سازی با سرور
    if (updatedExam?.id) queueExamSync(updatedExam.id);

    return {
      exam: updatedExam,
      result: updatedResult,
      finalScore: updatedResult.score,
      isFullyGraded: updatedResult.isEssayGraded !== false,
    };
  }, [queueExamSync]);

  // ============================================================
  // ===== ۲۱. توابع زمان‌بندی و محدودیت شرکت =====
  // ============================================================

  /**
   * بررسی بازه ورود به آزمون
   * @param {Object} exam - شی آزمون
   * @returns {boolean} آیا زمان ورود باز است
   */
  const isExamOpenForEntry = useCallback((exam) => {
    if (!exam) return false;
    if (!exam.startTime || !exam.endTime) return true;

    let start = new Date(exam.startTime);
    let end = new Date(exam.endTime);

    // اگر startTime معتبر نبود، سعی کن با date ترکیب کنی
    if (isNaN(start.getTime()) && exam.date) {
      start = new Date(`${exam.date}T${exam.startTime}:00`);
      end = new Date(`${exam.date}T${exam.endTime}:00`);
    }

    // ❗ اگر باز هم نامعتبر بود، false برگردان تا آزمون بسته محسوب شود
    if (isNaN(start.getTime()) || isNaN(end.getTime())) return false;

    const now = new Date();
    return now >= start && now <= end;
  }, []);

  /**
   * بررسی اینکه دانش‌آموز قبلاً در آزمون شرکت کرده
   * @param {string} examId - شناسه آزمون
   * @param {string} studentId - شناسه دانش‌آموز
   * @returns {boolean} آیا قبلاً شرکت کرده
   */
  const hasStudentParticipated = useCallback((examId, studentId) => {
    if (!examId || !studentId) return false;
    const exam = getExam(examId);
    if (!exam) return false;
    return exam.results?.some((r) => r.studentId === studentId) || false;
  }, [getExam]);

  /**
   * دریافت تعداد دفعات شرکت دانش‌آموز در یک آزمون
   * @param {string} examId - شناسه آزمون
   * @param {string} studentId - شناسه دانش‌آموز
   * @returns {number} تعداد دفعات شرکت
   */
  const getStudentAttempts = useCallback((examId, studentId) => {
    if (!examId || !studentId) return 0;
    const exam = getExam(examId);
    if (!exam) return 0;
    return exam.results?.filter((r) => r.studentId === studentId).length || 0;
  }, [getExam]);

  /**
   * بررسی اینکه دانش‌آموز مجاز به شرکت در آزمون است
   * @param {string} examId - شناسه آزمون
   * @param {string} studentId - شناسه دانش‌آموز
   * @returns {boolean} آیا مجاز به شرکت است
   */
  const canStudentAttempt = useCallback((examId, studentId) => {
    if (!examId || !studentId) return false;
    const exam = getExam(examId);
    if (!exam) return false;
    if (exam.statusType === 'closed') return false;
    if (!isExamOpenForEntry(exam)) return false;
    const attempts = getStudentAttempts(examId, studentId);
    const limit = exam.limitAttempts || 1;
    return attempts < limit;
  }, [getExam, isExamOpenForEntry, getStudentAttempts]);

  // ============================================================
  // ===== ۲۲. بررسی نیاز به تصحیح =====
  // ============================================================
  const examNeedsCorrection = useCallback((examId) => {
    if (!examId) return false;
    const exam = getExam(examId);
    if (!exam) return false;

    const hasEssay = exam.questions?.some(
      (q) => q.type === 'essay' || q.type === 'file'
    ) ?? false;
    if (!hasEssay) return false;

    const hasUncorrected = exam.results?.some(
      (r) => r.isEssayGraded === false
    ) ?? false;
    return hasUncorrected;
  }, [getExam]);

  // ============================================================
  // ===== ۲۳. دریافت تعداد دانش‌آموزان گروه =====
  // ============================================================
  const getTeamTotalStudents = useCallback((teamId) => {
    if (!teamId) return 0;

    try {
      const storedMembers = localStorage.getItem('teamMembers');
      if (storedMembers) {
        const members = JSON.parse(storedMembers);
        const count = members.filter((m) => m.teamId === teamId && m.status === 'active').length;
        if (count > 0) return count;
      }
    } catch (e) {
      console.warn('⚠️ Error counting team members from localStorage:', e);
    }

    try {
      const storedTeam = localStorage.getItem('team');
      if (storedTeam) {
        const team = JSON.parse(storedTeam);
        if (team && team.id === teamId && team.members) {
          return team.members.length || 0;
        }
      }
    } catch (e) {
      console.warn('⚠️ Error reading team:', e);
    }

    return 0;
  }, []);

  // ============================================================
  // ===== ۲۴. محاسبه آمار دانش‌آموز برای یک آزمون =====
  // ============================================================
  const getStudentStatsForExam = useCallback((exam, student) => {
    if (!exam || !student) {
      return { correct: 0, wrong: 0, unanswered: 0, pending: 0, wrongQuestions: [] };
    }

    let correct = 0;
    let wrong = 0;
    let unanswered = 0;
    let pending = 0;
    let wrongQuestions = [];

    (exam.questions || []).forEach((q, idx) => {
      const isEssay = q.type === 'essay' || q.type === 'file';
      
      const answer = student.answers?.find(
        (a) => a.questionIndex === idx || a.questionId === q.id
      );
      
      const detail = student.correctedDetails?.find(
        (d) => d.questionIndex === idx
      );

      if (isEssay) {
        if (detail) {
          if (detail.isCorrect === true) {
            correct++;
          } else if (detail.isCorrect === false) {
            wrong++;
            wrongQuestions.push(idx + 1);
          }
        } else if (answer && answer.text && answer.text.trim() !== '') {
          pending++;
        } else {
          unanswered++;
        }
      } else {
        if (answer) {
          if (answer.isCorrect) {
            correct++;
          } else {
            wrong++;
            wrongQuestions.push(idx + 1);
          }
        } else {
          unanswered++;
        }
      }
    });

    return { correct, wrong, unanswered, pending, wrongQuestions };
  }, []);

  // ============================================================
  // ===== ۲۵. توابع جدید برای آزمون‌های عمومی (با تفکیک چالش‌ها) =====
  // ============================================================

  /**
   * دریافت تمام آزمون‌های عمومی (فعال و غیربایگانی) - به جز چالش‌ها
   * @returns {Array} لیست آزمون‌های عمومی
   */
  const getGlobalExams = useCallback(() => {
    return exams.filter((e) =>
      !!e.isGlobal === true &&      // فقط عمومی واقعی (نه truthy)
      !e.isChallenge &&              // چالش هرگز در لیست عمومی نباشه
      !isStepQuiz(e) &&
      e.statusType !== 'archived'    // آرشیو نشده باشه
    );
  }, [exams]);

  /**
   * دریافت آزمون‌های عمومی بر اساس دسته‌بندی (پایه، درس، کتاب، فصل) - به جز چالش‌ها
   * @param {string} grade - پایه تحصیلی
   * @param {string} subject - درس
   * @param {string} book - کتاب
   * @param {string} chapter - فصل
   * @returns {Array} لیست آزمون‌های فیلتر شده
   */
    // 🔽 CHANGED: پارامتر پنجم (field) اضافه شد
  const getGlobalExamsByCategory = useCallback((grade, subject, book, chapter, field = null) => {
    const normalizedField = field ? curriculumNormalizeField(field) : null;
    return exams.filter((e) => {
      if (!e.isGlobal) return false;
      if (e.isChallenge) return false;
      if (isStepQuiz(e)) return false;
      if (e.statusType === 'archived') return false;
      if (grade && e.grade !== grade) return false;
      // 🔽 CHANGED: اگر field داده شده، فیلتر کن
      if (normalizedField) {
        if ((e.field || null) !== normalizedField) return false;
      }
      if (subject && e.subject !== subject) return false;
      if (book && e.book !== book) return false;
      if (chapter && e.chapter !== chapter) return false;
      return true;
    });
  }, [exams]);






    /**
   * 🔽 NEW: دریافت آزمون‌های یک پایه‌ی مشخص با فیلتر رشته
   * مفید برای صفحاتی که کاربر اول پایه رو انتخاب می‌کنه و باید رشته رو چک کنن
   * @param {string} grade - پایه تحصیلی
   * @param {string} field - رشته (riazi | tajrobi | ensani)
   * @param {boolean} isChallenge - اگر true فقط چالش‌ها، اگر false فقط آزمون‌های معمولی
   * @returns {Array}
   */
  const getExamsByGradeAndField = useCallback((grade, field = null, isChallenge = null) => {
    if (!grade) return [];
    const normalizedField = field ? curriculumNormalizeField(field) : null;
    const gradeNeedsField = curriculumNeedsField(grade);

    return exams.filter((e) => {
      if (e.statusType === 'archived') return false;
      if (e.grade !== grade) return false;
      // 🔽 برای ۱۰-۱۲ اگه فیلد داده شده، فیلتر کن
      if (gradeNeedsField && normalizedField) {
        if ((e.field || null) !== normalizedField) return false;
      }
      // 🔽 فیلتر نوع (چالش / آزمون معمولی)
      if (isChallenge === true && e.isChallenge !== true) return false;
      if (isChallenge === false && e.isChallenge === true) return false;
      return true;
    });
  }, [exams]);













  /**
   * دریافت تمام دسته‌بندی‌های موجود از آزمون‌های عمومی - به جز چالش‌ها
   * @returns {Object} آبجکت شامل لیست پایه‌ها، درس‌ها، کتاب‌ها و فصل‌ها
   */
   const getGlobalCategories = useCallback(() => {
    const categories = {
      grades: [],
      fields: [],   // 🔽 CHANGED
      subjects: [],
      books: [],
      chapters: [],
    };

    exams.forEach((e) => {
  if (!e.isGlobal || e.isChallenge || isStepQuiz(e) || e.statusType === 'archived') return;

      if (e.grade && !categories.grades.includes(e.grade)) {
        categories.grades.push(e.grade);
      }
      // 🔽 CHANGED: جمع‌آوری فیلدها
      if (e.field && !categories.fields.includes(e.field)) {
        categories.fields.push(e.field);
      }
      if (e.subject && !categories.subjects.includes(e.subject)) {
        categories.subjects.push(e.subject);
      }
      if (e.book && !categories.books.includes(e.book)) {
        categories.books.push(e.book);
      }
      if (e.chapter && !categories.chapters.includes(e.chapter)) {
        categories.chapters.push(e.chapter);
      }
    });

    // مرتب‌سازی
    categories.grades.sort((a, b) => {
      const order = ['دهم', 'یازدهم', 'دوازدهم', 'دهم تجربی', 'یازدهم تجربی', 'دوازدهم تجربی', 'دهم ریاضی', 'یازدهم ریاضی', 'دوازدهم ریاضی', 'دهم انسانی', 'یازدهم انسانی', 'دوازدهم انسانی'];
      return order.indexOf(a) - order.indexOf(b) || a.localeCompare(b);
    });
    // 🔽 CHANGED: مرتب‌سازی فیلدها
    categories.fields.sort((a, b) => {
      const order = ['riazi', 'tajrobi', 'ensani'];
      return order.indexOf(a) - order.indexOf(b) || a.localeCompare(b);
    });
    categories.subjects.sort();
    categories.books.sort();
    categories.chapters.sort((a, b) => {
      const numA = parseInt(a.replace(/\D/g, '')) || 0;
      const numB = parseInt(b.replace(/\D/g, '')) || 0;
      return numA - numB || a.localeCompare(b);
    });

    return categories;
  }, [exams]);

  /**
   * دریافت آمار آزمون‌های عمومی - به جز چالش‌ها
   * @returns {Object} آمار آزمون‌های عمومی
   */
const getGlobalExamStats = useCallback(() => {
  const globalExams = exams.filter((e) =>
    e.isGlobal === true && e.isChallenge !== true && !isStepQuiz(e)
  );
    return {
      total: globalExams.length,
      active: globalExams.filter((e) => e.statusType === 'active').length,
      closed: globalExams.filter((e) => e.statusType === 'closed').length,
      correction: globalExams.filter((e) => e.statusType === 'correction').length,
      pending: globalExams.filter((e) => e.statusType === 'pending').length,
      archived: globalExams.filter((e) => e.statusType === 'archived').length,
    };
  }, [exams]);





  // ================================================================
  // 🆕 STEP QUIZ APIS
  // ================================================================

  const getStepQuiz = useCallback(({ versionId, stepId }) => {
    if (!versionId || !stepId) return null;
    return exams.find((e) =>
      isStepQuiz(e) &&
      e.linkContext?.versionId === versionId &&
      e.linkContext?.stepId === stepId
    ) || null;
  }, [exams]);

  const getStepQuizByStepId = useCallback((stepId) => {
    if (!stepId) return null;
    return exams.find((e) => isStepQuiz(e) && e.linkContext?.stepId === stepId) || null;
  }, [exams]);

  const upsertStepQuiz = useCallback((quizData) => {
    if (!quizData) return null;

    // ✅ ID پایدار از کلید طبیعی — دیگه همیشه ID داره
    const stableId = quizData.id
      || `step-quiz-${quizData.linkContext?.versionId || 'v'}-${quizData.linkContext?.stepId || 's'}`;

    const existing = examsRef.current.find((e) => e.id === stableId);

    const sanitized = {
      ...quizData,
      id: stableId,
      isStepQuiz: true,
      isGlobal: false,
      isChallenge: false,
      isDailyChallenge: false,
      teamId: null,
      published: true,
      statusType: 'active',
      status: 'فعال',
      totalStudents: 0,
      passThreshold: quizData.passThreshold ?? 12,
      maxAttempts: quizData.maxAttempts ?? 2,
      retryPrice: quizData.retryPrice ?? 10000,
      limitAttempts: quizData.maxAttempts ?? 2,
      updatedAt: new Date().toISOString(),
    };

    if (existing) {
      updateExam(existing.id, sanitized);
      return examsRef.current.find((e) => e.id === existing.id) || sanitized;
    }

    const newExam = addExam({
      ...sanitized,
      createdAt: new Date().toISOString(),
    });
    return newExam;
  }, [addExam, updateExam]);

  const removeStepQuiz = useCallback((quizId) => {
    if (!quizId) return;
    try { deleteExam(quizId); } catch (e) { /* ignore */ }
  }, [deleteExam]);

  const removeStepQuizzesForStep = useCallback((stepId) => {
    if (!stepId) return;
    exams
      .filter((e) => isStepQuiz(e) && e.linkContext?.stepId === stepId)
      .forEach((q) => { try { deleteExam(q.id); } catch (e) {} });
  }, [exams, deleteExam]);

  const removeStepQuizzesForVersion = useCallback((versionId) => {
    if (!versionId) return;
    exams
      .filter((e) => isStepQuiz(e) && e.linkContext?.versionId === versionId)
      .forEach((q) => { try { deleteExam(q.id); } catch (e) {} });
  }, [exams, deleteExam]);

  const removeStepQuizzesForProject = useCallback((projectId) => {
    if (!projectId) return;
    exams
      .filter((e) => isStepQuiz(e) && e.linkContext?.projectId === projectId)
      .forEach((q) => { try { deleteExam(q.id); } catch (e) {} });
  }, [exams, deleteExam]);

  /** 🔑 access state (attempts + unlock) */
  const getStepQuizAccess = useCallback((userId, quizId) => {
    const empty = { attempts: [], unlockedWithPayment: [], passed: false };
    if (!userId || !quizId) return empty;

    const exam = exams.find((e) => e.id === quizId);
    if (!exam) return empty;

    const passThreshold = toNumber(exam.passThreshold, 12);
    const attempts = (exam.results || [])
      .filter((r) => idsEqual(r.studentId, userId))
      .map((r) => ({
        score: toNumber(r.score),
        passed: toNumber(r.score) >= passThreshold,
        submittedAt: r.submittedAt,
      }));

    // 🆕 کش آنلاک از engine (نه ref تعریف‌نشده) — هماهنگ با شعار «همه چیز از engine»
    let unlockedWithPayment = [];
    try {
      const unlockKey = `step-quiz-unlock-${userId}`;
      const all = booksEngine.get(unlockKey, {}) || {};
      unlockedWithPayment = Array.isArray(all[quizId]) ? all[quizId] : [];
    } catch (e) { /* ignore */ }

    return {
      attempts,
      unlockedWithPayment,
      passed: attempts.some((a) => a.passed),
    };
  }, [exams]);

  /**
   * 🔑 آنلاک آزمون مرحله — فقط بعد از verify موفق روی سرور.
   * این تابع دیگه خودش پرداخت نمی‌کنه؛ فقط وضعیت آنلاک رو از سرور می‌خونه/کش می‌کنه.
   * شروع پرداخت از طریق pay.stepQuizUnlock() در paymentService انجام میشه.
   */
  const getStepQuizUnlockStatus = useCallback(async (userId, quizId) => {
    if (!userId || !quizId) return { unlocked: false, entries: [] };
    try {
      // 🆕 خواندن unlock از engine (به‌جای fetch سرور با متغیر تعریف‌نشده)
      // این داده‌ها از طریق remoteSync به سرور push می‌شن
      const unlockKey = `step-quiz-unlock-${userId}`;
      const all = booksEngine.get(unlockKey, {}) || {};
      const entries = Array.isArray(all[quizId]) ? all[quizId] : [];
      return { unlocked: entries.length > 0, entries };
    } catch {
      return { unlocked: false, entries: [] };
    }
  }, []);

  /** 🔑 بررسی مجاز بودن شرکت */
  const canAttemptStepQuiz = useCallback((userId, quizId, opts = {}) => {
    if (!userId || !quizId) return { allowed: false, reason: 'not-ready' };
    const exam = exams.find((e) => e.id === quizId);
    if (!exam) return { allowed: false, reason: 'quiz-not-found' };

    const maxAttempts = opts.maxAttempts ?? toNumber(exam.maxAttempts, 2);
    const retryPrice = opts.retryPrice ?? toNumber(exam.retryPrice, 10000);

    const passThreshold = toNumber(exam.passThreshold, 12);
    const attempts = (exam.results || []).filter((r) => idsEqual(r.studentId, userId));
    const passed = attempts.some((r) => toNumber(r.score) >= passThreshold);

    let unlockedWithPayment = [];
    try {
      const unlockKey = `step-quiz-unlock-${userId}`;
      const all = booksEngine.get(unlockKey, {}) || {};
      unlockedWithPayment = Array.isArray(all[quizId]) ? all[quizId] : [];
    } catch (e) { /* ignore */ }

    if (passed) return { allowed: false, reason: 'already-passed' };
    if (attempts.length < maxAttempts) {
      return { allowed: true, attemptsLeft: maxAttempts - attempts.length };
    }
    if (unlockedWithPayment.length > 0) {
      const extraAttempts = unlockedWithPayment.length * maxAttempts;
      const usedExtra = attempts.length - maxAttempts;
      if (usedExtra < extraAttempts) {
        return { allowed: true, attemptsLeft: extraAttempts - usedExtra, paid: true };
      }
    }
    return { allowed: false, reason: 'payment-required', retryPrice };
  }, [exams]);






    // ============================================================
  // 🔽 CHANGED: helper های curriculum برای UI
  // ============================================================
  /**
   * آیا این پایه نیاز به انتخاب رشته داره؟
   * @param {string} grade
   * @returns {boolean}
   */
  const gradeNeedsField = useCallback((grade) => {
    return curriculumNeedsField(grade);
  }, []);

  /**
   * نرمال‌سازی شناسه‌ی رشته
   * @param {string} field
   * @returns {string|null}
   */
  const normalizeFieldId = useCallback((field) => {
    return curriculumNormalizeField(field);
  }, []);









  // ============================================================
  // ===== مقدار Context =====
  // ============================================================
  const value = {
    // ===== داده‌ها =====
    exams,

    // ===== توابع مدیریت آزمون =====
    addExam,
    updateExam,
    updateExamResults,
    updateCorrectionStatus,
    deleteExam,
    duplicateExam,
    getExam,

    // ===== توابع دریافت اطلاعات =====
    getPendingCorrections,
    getExamsByTeacher,
    getExamsByTeam,
    getExamsForStudent,
    getStudentResult,
    getStudentAllResults,
    getExamStats,

    // ===== توابع آرشیو و بازیابی =====
    archiveExam,
    restoreExam,

    // ===== توابع عضویت =====
    checkUserMembership,

    // ===== توابع تشریحی =====
    getEssayAnswers,
    updateEssayCorrection,
    processCorrection,

    // ===== توابع کمکی =====
    examNeedsCorrection,
    getTeamTotalStudents,
    getStudentStatsForExam,

    // ===== توابع زمان‌بندی و محدودیت =====
    isExamOpenForEntry,
    hasStudentParticipated,
    getStudentAttempts,
    canStudentAttempt,



      // 🆕 STEP QUIZ APIS
  getStepQuiz,
  getStepQuizByStepId,
  upsertStepQuiz,
  removeStepQuiz,
  removeStepQuizzesForStep,
  removeStepQuizzesForVersion,
  removeStepQuizzesForProject,
  getStepQuizAccess,
  canAttemptStepQuiz,


    // ===== توابع جدید برای آزمون‌های عمومی =====
        // ===== توابع جدید برای آزمون‌های عمومی =====
    getGlobalExams,
    getGlobalExamsByCategory,
    getGlobalCategories,
    getGlobalExamStats,
    isGlobalAdmin,
    GLOBAL_ADMINS,



    // 🔽 CHANGED: توابع جدید برای پشتیبانی از رشته
    getExamsByGradeAndField,
    gradeNeedsField,
    normalizeFieldId,

    // ===== توابع ابزار صادر شده =====
    toNumber,
    calculatePassThreshold,
    sanitizeHtml,
  };

  return (
    <ExamContext.Provider value={value}>
      {children}
    </ExamContext.Provider>
  );
};

// ============================================================
// ===== Hook برای استفاده از Context =====
// ============================================================
export const useExams = () => {
  const context = useContext(ExamContext);
  if (!context) {
    throw new Error('❌ useExams must be used within an ExamProvider');
  }
  return context;
};

export default ExamProvider;